import React, { Fragment } from 'react';
import { classSet } from '@umu/umu-dom';
import './index.scss';

interface IFormLabelProps {
    prefixCls?: string;// 样式前缀
    label: string | JSX.Element;
    isRequire?: boolean;
    suffix?: string | JSX.Element;
    children: string | JSX.Element;
    className?: string;
}
const FormLabel = (props: IFormLabelProps) => {
    const { prefixCls = 'micro-page-form-label', className = '', label, children, isRequire = false, suffix } = props;
    return (
        <Fragment>
            <div className={`${prefixCls} ${className}`}>
                <div
                    className={classSet({
                        [`${prefixCls}-require`]: isRequire,
                    })}
                >
                    {label}
                </div>
                {suffix && <div className={`${prefixCls}-suffix`}>{suffix}</div>}
            </div>
            <div className={`${prefixCls}-children`} >{children}</div>
        </Fragment>
    );
};
export {
    FormLabel
}
